import { CommonModule } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ToolbarComponent } from "../../../shared/components/toolbar/toolbar.component";
import { Observable } from "rxjs";
import { ICategory } from "../../model/category.model";
import { CategoryService } from "../../services/category.service";
import { Router, RouterModule } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ToastService } from "../../../shared/services/toast.service";

@Component({
    selector: 'clp-category-list',
    styleUrls: ['./categoryList.component.scss'],
    templateUrl: './categoryList.component.html',
    imports: [
        RouterModule,
        TranslateModule,
        CommonModule,
        ToolbarComponent
    ],
    providers: [
        CategoryService,
        ToastrService
    ]
})

export class CategoryListComponent implements OnInit {
    private categoryService = inject(CategoryService);
    private router = inject(Router);
    private toastService = inject(ToastService);
    private translate = inject(TranslateService);
    
    categories$!: Observable<ICategory[]>;
    ngOnInit(): void {
        this.categories$ = this.categoryService.getCategories();
    }

    editCategory(id: string | undefined ) {
        this.router.navigate(['updateCategory', id]);
    }

    deleteCategory(id: string | undefined ) {        
        if (id === undefined || id === null)
            return;

        var return$ = this.categoryService.deleteCategory(id);

        return$.subscribe(category => {
            if (category !== undefined && category !== null && category.id !== null) {                
                this.toastService.show(this.translate.instant("category.delete.successMessage"), "");
                this.categories$ = this.categoryService.getCategories();               
            }
        });
    }
}
